import React from "react";
import Button from "../../../../reusable-components/buttons/Button";
import TableWrapper from "../../../../reusable-components/table/TableWrapper";
import { linkTextPrimary } from "../../../../theme/lightTheme";

export default function FAQList({
  faqList,
  setEditFAQDetails,
  setShowAddForm,
}) {
  const onClickEdit = (faq) => {
    setEditFAQDetails(faq);
    setShowAddForm(true);
  };
  return (
    <TableWrapper>
      <thead className="bg-white text-sm">
        <tr>
          <th
            scope="col"
            className="px-6 py-3 font-medium text-slate-900 uppercase tracking-wider text-left"
          >
            Question
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left font-medium text-slate-900 uppercase tracking-wider"
          >
            Answer
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-right font-medium text-slate-900 uppercase tracking-wider"
          >
            Actions
          </th>
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-slate-100 text-slate-600">
        {faqList.length > 0 &&
          faqList.map((faq, index) => (
            <tr key={index}>
              <td className="px-6 py-4 whitespace-nowrap text-sm flex items-center">
                {faq.faqquestion}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {faq.faqanswer}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                <div className="flex justify-end">
                  <Button
                    onClick={() => onClickEdit(faq)}
                    aria-label="Edit FAQ Details"
                    className={linkTextPrimary}
                  >
                    Edit
                  </Button>
                </div>
              </td>
            </tr>
          ))}
      </tbody>
    </TableWrapper>
  );
}
